import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import S from 'StyledDatepicker.js';

const Datepicker = ({cb, ...rest}) => {

    const handleChange = (date) => {
        cb(date);
    };

    return (
        <S.Datepicker as={DatePicker} {...rest} onChange={handleChange}></S.Datepicker>
    );
};

export default Datepicker;